import {Component, OnInit, ViewChild} from '@angular/core';
import {AutorizacaoService} from "../services/autorizacao.service";
import {ConstantsService} from "../fidelidade/ConstantsService";
import {EmpresasService} from "../superadmin/services/empresas.service";
import {ActivatedRoute, Router} from "@angular/router";
import {Produtos2Component} from "../superadmin/produtos2/produtos2.component";
import {DialogRef, DialogService} from "@progress/kendo-angular-dialog";
import {KendoPopupUtils} from "../lib/KendoPopupUtils";
import {OfertasBoasVindasComponent} from "../compartilhado/ofertas-boas-vindas/ofertas-boas-vindas.component";
import {temPublicacaoCatalogoIfoodHabilitada} from '../canais-venda/canais-venda.logic';

@Component({
  selector: 'app-tela-cadastro-produtos',
  templateUrl: './tela-cadastro-produtos.component.html',
  styleUrls: ['./tela-cadastro-produtos.component.scss']
})
export class TelaCadastroProdutosComponent implements OnInit {
  empresa;
  usuario: any = {};
  confirmeRemover = false;
  removendo = false;
  textoConfirmacaoCatalogo = '';
  erroRemoverCatalogo: string;
  readonly fraseConfirmacaoCatalogo = 'LIMPAR CATALOGO';
  remocoesCatalogo: any[] = [];
  carregandoRemocoesCatalogo = false;
  confirmeRestaurar = false;
  historicoCatalogoSelecionado: any;
  textoConfirmacaoRestauracao = '';
  restaurandoCatalogo = false;
  erroRestaurarCatalogo: string;
  readonly fraseConfirmacaoRestauracao = 'RESTAURAR CATALOGO';
  totalProdutosCatalogo = 0;
  temModuloTabelaPrecos = false;
  priceTablesPanelOpen = false;
  abrirTabelaPrecosPelaUrl = false;

  @ViewChild('telaProdutos', {static: false}) telaProdutos: Produtos2Component;
  constructor(private constantsService: ConstantsService, private autorizacaoService: AutorizacaoService,
              private router: Router, private dialogService: DialogService,
              private empresaService: EmpresasService, private activatedRoute: ActivatedRoute) {


  }

  ngOnInit() {
    this.usuario = this.autorizacaoService.getUser() || {};
    this.constantsService.moduloTabelaPrecos$.subscribe((ativo) => {
      this.temModuloTabelaPrecos = !!ativo;
      if (this.temModuloTabelaPrecos && this.abrirTabelaPrecosPelaUrl)
       this.abraTabelaPrecos();
    });
    this.activatedRoute.queryParams.subscribe((params) => {
      this.abrirTabelaPrecosPelaUrl = params.tabelasPrecos === '1';
      if (this.abrirTabelaPrecosPelaUrl && this.temModuloTabelaPrecos)
        this.abraTabelaPrecos();
    });
    this.constantsService.empresa$.subscribe( data => {
        this.empresa  = data
        if(this.empresa?.catalogo){
          this.carregueRemocoesCatalogo();
          if(this.activatedRoute.snapshot.params.id){
              setTimeout(() => {
                this.telaProdutos.abrirTelaEditarProduto(this.activatedRoute.snapshot.params.id)
              }, 200)
          }
        }
    })
  }

  abraTabelaPrecos() {
    this.router.navigateByUrl('/admin/tabelas-precos').then( () => {
    });
  }

  get publicacaoCatalogoIfoodHabilitada(): boolean {
    return temPublicacaoCatalogoIfoodHabilitada(this.empresa);
  }

  // O menu "Ferramentas" desta tela e *ngIf="usuario.admin": o lojista comum nao o ve,
  // por isso a entrada aqui e um botao no cabecalho, e nao um item de menu como na V2.
  abraOfertasBoasVindas() {
    if(!this.empresa?.id) return;

    const windowRef: DialogRef = this.dialogService.open({
      title: null,
      content: OfertasBoasVindasComponent,
      minWidth: 320,
      width: window.innerWidth > 900 ? 900 : window.innerWidth,
      maxHeight: window.innerHeight - 80
    });

    const tela: OfertasBoasVindasComponent = windowRef.content.instance;

    tela.windowRef = windowRef;
    tela.empresa = this.empresa;
    // a previa mostra as ofertas reais desta loja, entao vai a lista ja carregada
    tela.produtos = this.telaProdutos ? (this.telaProdutos.produtos || []) : [];

    KendoPopupUtils.abriuPopupNgBootstrap(windowRef);
    windowRef.result.subscribe(() => { });
  }

  fecheTabelaPrecos() {
    this.priceTablesPanelOpen = false;
  }

  abraEditorProdutoLegado(produtoId: number) {
    this.fecheTabelaPrecos();
    setTimeout(() => {
      this.telaProdutos?.abrirTelaEditarProduto(produtoId);
    }, 0);
  }

  removerCatalogo(){
    this.textoConfirmacaoCatalogo = '';
    this.erroRemoverCatalogo = null;
    this.confirmeRemover = true;
  }

  canceleRemoverCatalogo() {
    if(this.removendo) return;

    this.confirmeRemover = false;
    this.textoConfirmacaoCatalogo = '';
    this.erroRemoverCatalogo = null;
  }

  digitouConfirmacaoCatalogo(): boolean {
    return this.textoConfirmacaoCatalogo === this.fraseConfirmacaoCatalogo;
  }

  get remocoesCatalogoPendentes(): any[] {
    return this.remocoesCatalogo.filter((historico: any) => !historico.restaurado);
  }

  async carregueRemocoesCatalogo() {
    if(!this.usuario.admin || this.carregandoRemocoesCatalogo) return;

    this.carregandoRemocoesCatalogo = true;
    try {
      this.remocoesCatalogo = await this.empresaService.listeRemocoesCatalogo() as any[] || [];
    } catch (erro) {
      this.remocoesCatalogo = [];
    } finally {
      this.carregandoRemocoesCatalogo = false;
    }
  }

  abraRestaurarCatalogo() {
    this.historicoCatalogoSelecionado = this.remocoesCatalogoPendentes[0] || null;
    this.textoConfirmacaoRestauracao = '';
    this.erroRestaurarCatalogo = null;
    this.confirmeRestaurar = true;
  }

  canceleRestaurarCatalogo() {
    if(this.restaurandoCatalogo) return;

    this.confirmeRestaurar = false;
    this.historicoCatalogoSelecionado = null;
    this.textoConfirmacaoRestauracao = '';
    this.erroRestaurarCatalogo = null;
  }

  digitouConfirmacaoRestauracao(): boolean {
    return this.textoConfirmacaoRestauracao === this.fraseConfirmacaoRestauracao;
  }

  atualizeTotalProdutos(total: number) {
    this.totalProdutosCatalogo = Number(total || 0);
  }

  async restaureCatalogo() {
    if(this.restaurandoCatalogo || !this.historicoCatalogoSelecionado ||
       !this.digitouConfirmacaoRestauracao()) return;

    this.restaurandoCatalogo = true;
    this.erroRestaurarCatalogo = null;
    try {
      await this.empresaService.restaureCatalogo(
        this.historicoCatalogoSelecionado.id,
        this.textoConfirmacaoRestauracao
      );
      window.location.reload();
    } catch (erro) {
      this.restaurandoCatalogo = false;
      this.erroRestaurarCatalogo = erro;
    }
  }

  async limparCache(){
    const response: any = await fetch('/empresas/me/cache/reset');

    if(response.status === 200)   window.location.reload();
    else alert('Erro Http ' + response.status + ": " + response.statusText)
  }

  removaCatalogo(){
    if(this.removendo || !this.digitouConfirmacaoCatalogo()) return;

    this.removendo = true;
    this.erroRemoverCatalogo = null;

    this.empresaService.limpeCatalogoDaLoja(false, this.textoConfirmacaoCatalogo).then((resposta: any) => {
      window.location.reload();
    }).catch((err) => {
      this.removendo = false;
      this.erroRemoverCatalogo = err;
    })
  }

}
